import type { CityConfig } from "../city-template/types";

export const greensboroConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Greensboro",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "greensboro",
  route: "/cities/greensboro",
  title: "Emergency Passport Greensboro, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Greensboro, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Guilford County and the Piedmont Triad. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Greensboro, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Greensboro and Piedmont Triad area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20panoramic%20view%20of%20Greensboro%20North%20Carolina%20downtown%20skyline%20with%20modern%20buildings%20and%20historic%20architecture%2C%20the%20Greensboro%20Cultural%20Center%20visible%2C%20warm%20golden%20afternoon%20sunlight%20illuminating%20the%20city%2C%20lush%20green%20tree-lined%20streets%20and%20parks%20in%20the%20foreground%2C%20rolling%20Piedmont%20hills%20in%20the%20background%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20natural%20warm%20colors%20and%20vibrant%20green%20landscape%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=greensboro-hero-nc-001&orientation=landscape",
  heroImageAlt: "Greensboro North Carolina downtown skyline with the Piedmont landscape",
  geoPosition: "36.0726;-79.7920",
  geoPlacename: "Greensboro, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 350 miles northeast of Greensboro — about 5 hours via I-85",
  },
  nearbyCitiesZips: [
    { name: "Greensboro", zips: "27401–27499" },
    { name: "High Point", zips: "27260, 27261, 27262, 27263, 27265" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Burlington", zips: "27215, 27216, 27217" },
    { name: "Kernersville", zips: "27284, 27285" },
    { name: "Thomasville", zips: "27360, 27361" },
    { name: "Asheboro", zips: "27203, 27204, 27205" },
    { name: "Reidsville", zips: "27320, 27323" },
    { name: "Eden", zips: "27288, 27289" },
    { name: "Graham", zips: "27253" },
    { name: "Mebane", zips: "27302" },
    { name: "Mount Airy", zips: "27030" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Greensboro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Piedmont Triad Hub", desc: "Serving Greensboro, Winston-Salem, High Point, and the entire Triad" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Emergency passport help in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Urgent passport services in High Point, NC", route: "/cities/high-point" },
    { name: "Same-day passport help in Durham, NC", route: "/cities/durham" },
    { name: "Passport courier services in Burlington, NC", route: "/burlington" },
    { name: "Fast passport renewal in Asheboro, NC", route: "/cities/asheboro" },
    { name: "Passport courier services in Kernersville, NC", route: "/cities/kernersville" },
    { name: "Passport courier services in Thomasville, NC", route: "/cities/thomasville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Greensboro remotely via secure courier. We do not have a walk-in office in Greensboro — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Guilford County and the Piedmont Triad area travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Guilford County and the Piedmont Triad including Forsyth and Alamance counties",
  serviceAreaIntro: "From downtown Greensboro to the suburbs of High Point and Winston-Salem, from Kernersville to Thomasville and Asheboro — Fast Passport Center serves the entire Piedmont Triad region. We regularly help travelers from Burlington, Reidsville, and Mebane get their passports fast.",
  nearbyCitiesIntro: "We serve all Greensboro neighborhoods and the surrounding Piedmont Triad area including High Point, Winston-Salem, Burlington, Kernersville, Thomasville, Asheboro, Reidsville, Eden, Graham, Mebane, and Mount Airy. If you are anywhere in Guilford, Forsyth, Alamance, or Randolph counties, we have you covered.",
  howItWorksIntro: "Most Greensboro travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Greensboro travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Greensboro and Piedmont Triad travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Greensboro? Here are the most common ones we hear from Guilford County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Greensboro international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Thomas H.",
      location: "Greensboro, NC",
      rating: 5,
      text: "My passport expired the week before a conference in Berlin. Fast Passport Center had my renewal in 5 days. Never had to leave the Piedmont Triad. Excellent service.",
      service: "Passport Renewal",
    },
    {
      name: "Karen S.",
      location: "High Point, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in Canada. Got it in 30 hours. The team was incredibly responsive and professional. True lifesavers.",
      service: "Emergency Passport",
    },
    {
      name: "Brandon M.",
      location: "Winston-Salem, NC",
      rating: 5,
      text: "Business trip to Dubai came up with 7 days notice. They got me a passport in 4 business days. The communication was outstanding throughout the process.",
      service: "Emergency Passport",
    },
    {
      name: "Nicole D.",
      location: "Burlington, NC",
      rating: 5,
      text: "First passport for my son before his mission trip to Guatemala. Fast Passport Center helped us navigate every step. Ready in 5 days with zero stress.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "greensboro-1",
      name: "Greensboro Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Murrow Blvd",
      city: "Greensboro",
      state: "NC",
      zip: "27401",
      phone: "(336) 373-7825",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Greensboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Greensboro facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "greensboro-2",
      name: "High Point Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1114 N Main St",
      city: "High Point",
      state: "NC",
      zip: "27262",
      phone: "(336) 882-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southwest Greensboro, High Point area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for High Point and southwest Guilford County residents. Less crowded than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "greensboro-3",
      name: "Winston-Salem Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "251 N Main St",
      city: "Winston-Salem",
      state: "NC",
      zip: "27101",
      phone: "(336) 631-5183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Greensboro, Forsyth County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Forsyth County and the Winston-Salem area. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "greensboro-4",
      name: "Burlington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "422 S Lexington Ave",
      city: "Burlington",
      state: "NC",
      zip: "27215",
      phone: "(336) 229-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Greensboro, Alamance County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Alamance County and east Guilford County. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "greensboro-5",
      name: "Guilford County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "201 W Market St",
      city: "Greensboro",
      state: "NC",
      zip: "27401",
      phone: "(336) 641-4753",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Guilford County Courthouse, downtown Greensboro",
      website: "https://www.guilfordcountync.gov/",
      websiteLabel: "Guilford County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "greensboro-6",
      name: "Kernersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 E Mountain St",
      city: "Kernersville",
      state: "NC",
      zip: "27284",
      phone: "(336) 992-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Greensboro, between Greensboro and Winston-Salem",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kernersville and the area between Greensboro and Winston-Salem. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Greensboro photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Guilford County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Greensboro applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Guilford County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Greensboro travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Greensboro." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Greensboro address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Greensboro before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Greensboro for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Greensboro?", a: "Fast Passport Center offers fast passport renewal in Greensboro in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Greensboro?", a: "The nearest regional passport agency to Greensboro is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 350 miles northeast via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Greensboro without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Greensboro?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 5 hours from Greensboro — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Guilford County residents." },
    { q: "Do you serve the entire Piedmont Triad?", a: "Absolutely. Fast Passport Center serves the entire Piedmont Triad including Greensboro, Winston-Salem, High Point, Burlington, Kernersville, Thomasville, Asheboro, Reidsville, and Eden. Our courier service works seamlessly from any address in Guilford, Forsyth, Alamance, or Randolph counties." },
    { q: "Can I expedite a child passport in Greensboro?", a: "Yes. Fast Passport Center expedites child passports in Greensboro for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Guilford County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Greensboro with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Greensboro", address: "218 S Elm St, Greensboro, NC 27401", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Greensboro", address: "2504 Battleground Ave, Greensboro, NC 27408", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — High Point", address: "2710 N Main St, High Point, NC 27265", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Greensboro", address: "3302 W Friendly Ave, Greensboro, NC 27410", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Winston-Salem", address: "1001 S Stratford Rd, Winston-Salem, NC 27103", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Burlington", address: "1445 University Dr, Burlington, NC 27215", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Kernersville", address: "1040 S Main St, Kernersville, NC 27284", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Thomasville", address: "1585 National Hwy, Thomasville, NC 27360", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Greensboro",
      address: "3411 W Wendover Ave, Greensboro, NC 27407",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — High Point",
      address: "1624 N Main St, High Point, NC 27262",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Winston-Salem",
      address: "2001 Silas Creek Pkwy, Winston-Salem, NC 27103",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Forsyth County and the Winston-Salem area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Burlington",
      address: "2642 Alamance Rd, Burlington, NC 27215",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Alamance County and east Guilford County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "10 miles west of downtown Greensboro",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Primary airport serving the Piedmont Triad. Direct flights to major domestic hubs and seasonal international routes. Convenient for Greensboro, Winston-Salem, and High Point travelers.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: true,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "70 miles east of Greensboro",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel from the Piedmont Triad.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "90 miles south of Greensboro",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. Consider for international travel from the Piedmont Triad.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Guilford County Register of Deeds',
      description: 'Marriage licenses and records for Guilford County. Apply in person or request certified copies.',
      url: 'https://www.guilfordcountync.gov/our-county/register-of-deeds',
    },
    {
      label: 'Guilford County Clerk of Superior Court',
      description: 'Divorce records and decrees for Guilford County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/guilford-county/guilford-county-clerk-of-superior-court',
    },
  ],
};